export default __webpack_public_path__ + "static/media/without-submission.da3dd77c.png";